/**
 * Generated by orval 🍺
 * Do not edit manually.
 * clarityrcm.api
 * OpenAPI spec version: 1.0
 */
import type { UserPermissionsResponse } from "../../../../../lib/api-types/schemas";

import { authenticatedClient } from "../../authenticatedClient";

export type getApiMePermissionsResponse200 = {
  data: UserPermissionsResponse;
  status: 200;
};

export type getApiMePermissionsResponse401 = {
  data: void;
  status: 401;
};

export type getApiMePermissionsResponse403 = {
  data: void;
  status: 403;
};

export type getApiMePermissionsResponse404 = {
  data: void;
  status: 404;
};

export type getApiMePermissionsResponseSuccess =
  getApiMePermissionsResponse200 & {
    headers: Headers;
  };
export type getApiMePermissionsResponseError = (
  | getApiMePermissionsResponse401
  | getApiMePermissionsResponse403
  | getApiMePermissionsResponse404
) & {
  headers: Headers;
};

export const getGetApiMePermissionsUrl = () => {
  return `/api/me/permissions`;
};

/**
 * **Actor types:** `clinic`, `internal`
 *
 * Any authenticated interactive user can call this — no read:users required.
 * @summary Returns the caller's effective permission names (direct grants unioned with
grants inherited from every assigned role) plus a session version used by
the SignalR permissions-changed handshake.
 */
export const getApiMePermissions = async (
  options?: Parameters<typeof authenticatedClient>[1],
): Promise<getApiMePermissionsResponseSuccess> => {
  return authenticatedClient<getApiMePermissionsResponseSuccess>(
    getGetApiMePermissionsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};
